// @flow
import { connect } from 'react-redux';
import type { State, TargetType } from '../../../types';
import { TYPE } from '../../../constants/targetConstants';
import { vehicleUserIdSelector } from '../../../selectors/vehicleSelectors';
import { makeDataSourceSelector, makeCarEntityAutoSelector, makeCarSessionStartSelector, callsignSelector as carCallsignSelector } from '../../../selectors/carSelectors';
import { makePlaneEntitySelector, callsignSelector as planeCallsignSelector } from '../../../selectors/planeSelectors';
import targetActions from '../../../actions/targetActions';
import TargetListItem from '../TargetListItem';
import type { Props } from '../TargetListItem';

type OwnProps = $ReadOnly<{|
    type: TargetType,
    icao: string
|}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    let callsign;
    let dataSource;
    let sessionStart;
    let hasOperator;

    if(props.type === TYPE.car) {
        const targetBuffer = makeCarEntityAutoSelector(props.icao)(state);
        callsign = carCallsignSelector(props.icao, targetBuffer)(state);
        sessionStart = makeCarSessionStartSelector(props.icao)(state);
        dataSource = makeDataSourceSelector(props.icao)(state);
        hasOperator = Boolean(vehicleUserIdSelector(props.icao)(state));
    }
    else if(props.type === TYPE.plane) {
        const targetBuffer = makePlaneEntitySelector(props.icao)(state);
        callsign = planeCallsignSelector(props.icao, targetBuffer)(state);
    }
    else {
        throw new Error(`Unknown type ${props.type}`);
    }

    return {
        callsign,
        dataSource,
        sessionStart,
        hasOperator
    };
};

const mapDispatchToProps = {
    selectTarget: targetActions.selectThunk
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(TargetListItem);